import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Box, Divider, Grid, Paper, Typography, Zoom } from '@material-ui/core';
import { useStylesAuth } from '../../styles/auth/style';
import { useTotemBasic } from '../../hooks/useCases/useTotemBasic';
import { ButtonGeneric } from '../atomic/atoms/Buttons';
import { CustomDivider } from '../atomic/atoms/Divider';
import { useSelector } from 'react-redux';
import { GenericModal } from '../atomic/organisms/GenericModal';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';

const stylesTeclas = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: '#A178C5',
  color: "#fff",
  fontSize: "1.5em",
  cursor: "pointer",
  padding: "0.5em",
  transition: "background-color 0.3s ease"
};

const hoverStylesTeclas = {
  backgroundColor: '#7F5A91',
};

const Logo = () => {
  const classesAuth = useStylesAuth("light");
  return (
    <div
      style={{ margin: "auto" }}
      className={classesAuth.imageTotem}
    />
  )
}

export const TotemBasicHome = () => {
  const totem = useTotemBasic();
  const [currentView, setCurrentView] = useState("opciones");
  const { opciones } = useSelector(state => state.totemBasic);
  const [modal, setModal] = useState({ open: false, value: null });
  const [subOpciones, setSubOpciones] = useState(null);
  useEffect(() => totem.get.opciones(), [])
  useEffect(() => {
    if (currentView !== "opciones") {
      const timer = setTimeout(() => {
        setCurrentView("opciones");
        setModal({ ...modal, open: false });
      }, currentView === "confirmOption" ? 10000 : 20000);
      return () => clearTimeout(timer);
    }
  }, [currentView]);

  const handleOptionSelect = (item) => {
    if (item.subOpciones.length > 0) {
      setModal({ open: false, opcion: item });
      setSubOpciones({ list: item.subOpciones, idOpcion: item.id });
      setCurrentView("subOpciones");
    } else {
      setModal({ open: true, opcion: item });
    }
  };

  return (
    <>
      <div style={{ display: "grid", justifyContent: "center", alignItems: "center", height: "90vh", padding: "2.5em" }}>
        {currentView === "opciones" && (
          <Zoom in>
            <Grid container justify='center' component={Paper} elevation={5} style={{ padding: "1.5em" }}>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Logo />
              </Grid>

              <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                <Typography variant='h4' style={{ fontSize: "2em", marginBottom: "0.6em", fontWeight: "bold" }}>
                  BIENVENIDO AL CENTRO MEDICO MORÓN
                </Typography>
              </Grid>
              <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                <Typography variant='h4' style={{ fontSize: "2em" }}>
                  Seleccioná algunas de las siguientes opciones:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                  {
                    opciones.map((item, index) => (
                      <Grid
                        key={index}
                        item xs={3}
                        component={Paper}
                        elevation={3}
                        style={stylesTeclas}
                        onMouseOver={e => e.currentTarget.style.backgroundColor = hoverStylesTeclas.backgroundColor}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = stylesTeclas.backgroundColor}
                        onClick={() => handleOptionSelect(item)}
                      >
                        {item.descripcion}
                      </Grid>
                    ))
                  }
                </Grid>
              </Grid>
            </Grid>
          </Zoom>
        )}
        {currentView === "subOpciones" && (
          <Zoom in>
            <Grid container justify='center' component={Paper} elevation={5} style={{ padding: "1.5em" }}>
              <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                <Typography variant='h4' style={{ fontSize: "2em", marginBottom: "0.5em" }}>
                  Seleccioná algunas de las siguientes opciones:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                  <Grid item xs={11} component={Paper} elevation={2}>
                    <Grid container spacing={2} justify='center' style={{ margin: "1.5em 0", display: "flex", justifyContent: "center", gap: "1.2em" }}>
                      {
                        subOpciones.list.map((item, index) => (
                          <Grid
                            key={index}
                            item xs={3}
                            component={Paper}
                            elevation={3}
                            style={stylesTeclas}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = hoverStylesTeclas.backgroundColor}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = stylesTeclas.backgroundColor}
                            onClick={() => setModal({
                              ...modal,
                              open: true,
                              subOpcion: item,
                            })
                            }
                          >
                            {item.descripcion}
                          </Grid>
                        ))
                      }
                    </Grid>
                    <ButtonGeneric
                      text="VOLVER"
                      size="large"
                      fullWidth
                      onClick={() => setCurrentView("opciones")}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Zoom>
        )}
        {currentView === "confirmOption" && (
          <Zoom in>
            <Grid container justify='center' component={Paper} style={{ padding: 20 }}>
              <Grid item xs={12}>
                <Logo />
                <CustomDivider />
              </Grid>
              <Grid item xs={12} style={{ margin: "1em 0", textAlign: "center" }}>
                <Typography variant='h4' style={{ fontSize: "2em", marginBottom: "0.5em" }}>
                  Opción Confirmada
                </Typography>
                <Box align="center" style={{ margin: "1em" }}>
                  <PrintModel opcion={modal.opcion} subOpcion={modal.subOpcion} ticket={modal.ticket} />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <ButtonGeneric
                  text="VOLVER"
                  size="large"
                  fullWidth
                  onClick={() => setCurrentView("opciones")}
                />
              </Grid>
            </Grid>
          </Zoom>
        )}
      </div>
      <GenericModal
        open={modal.open}
        title={<Typography variant='h4' >{modal.subOpcion ? modal.subOpcion?.descripcion.toUpperCase() : modal.opcion?.descripcion.toUpperCase()}</Typography>}
        handleClose={() => setModal({ ...modal, open: false })}
        textButton="ACEPTAR"
        handleButton={
          () => {
            totem.insert.solicitud({
              idOpcion: modal.opcion?.id,
              idSubOpcion: modal.subOpcion?.id ?? null
            },
              (ticket) => {
                setModal({ ticket, ...modal, open: false })
                setCurrentView("confirmOption")
              })
          }}
        fullWidthButtons
      >
        <div style={{ textAlign: "center", margin: "0.5em" }}>
          <Typography variant='button' style={{ color: "#555", fontSize: "1.5em" }}>¿Confirmás esta opción?</Typography>
        </div>
      </GenericModal>
    </>
  )
}

const typographyProps = {
  variant: 'caption',
  style: {
    fontSize: "1.3em",
    fontWeight: "bolder",
  }
};

const PrintModel = ({ opcion, subOpcion, ticket }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });
  useEffect(() => {
    handlePrint()
  }, [])


  const listItems = [
    {
      children: (
        <Logo />
      )
    },
    {
      children: (
        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
          <Typography {...typographyProps}>{`${moment().format("DD/MM/YYYY")}`}</Typography>
          <Typography {...typographyProps}>{`${moment().format("hh:mm")}hs`}</Typography>
        </div>
      )
    },

    {
      children: (
        <div style={{ textAlign: "center" }}>
          <Typography {...{ ...typographyProps, fontSize: "1.5em" }}>
            {`Opción seleccionada: ${opcion?.descripcion}${subOpcion ? ` - ${subOpcion.descripcion}` : ""}`}
          </Typography>
        </div>
      ),
    },

    {
      children: (
        <div style={{ textAlign: "center" }}>
          <Typography style={{ fontSize: "3em", fontWeight: "bold" }}>{ticket ?? ""}</Typography>
        </div>
      ),
    },
  ]
  return (
    <div style={{ display: 'none' }}>
      <Grid ref={componentRef} container>
        {listItems.map(({ children }, index) => (
          <Fragment key={index}>
            {children && (
              <>
                <Grid item xs={12} style={{ padding: "1em" }}>
                  {children}
                </Grid>
                {(listItems.length - 1) !== index && (<Grid item xs={12} component={Divider} />)}
              </>
            )}
          </Fragment>
        ))}
      </Grid>
    </div>
  );
};